import React, { useContext } from 'react'
import CreationSourceURLField from '../../../../../../components/form-fields/super-cut/source-url'
import styled from 'styled-components'
import { CreationCaptureInfoContext } from '../manager'
import { Wrap } from 'shared/components/edit-panel/info/textfield-async'
import CreationToolUploadField from '../../../../../../types/upload-field'

const SourceURL = styled(CreationSourceURLField)`
    grid-column: span 2;

    ${Wrap} {
        margin-bottom: 0px;
    }
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationCaptureInfoSourceUrlField = ({ className, field }: Props) => {
    const { sourceUrl, setSourceUrl } = useContext(CreationCaptureInfoContext)

    return (
        <SourceURL
            {...{
                className,
                field,
                sourceUrl,
                onChange: setSourceUrl,
            }}
        />
    )
}

export default CreationCaptureInfoSourceUrlField
